<!-- <p-panelMenu [multiple]="false" [model]="model"></p-panelMenu> -->
<p-panelMenu [multiple]="true" [model]="model2 | async"></p-panelMenu>
